import { p } from '@/utils/content-blocks';

/** 故障排除：7 个 H2 区块，每区含 Problem→Solution 卡 */
export const TROUBLESHOOTING_SECTIONS = [
	{
		id: 'not-working-overview',
		h2: 'GB WhatsApp Not Working Issues',
		blocks: [
			p([
				{
					text: 'When GB WhatsApp stops opening, verifying, or sending messages, the fix is usually a mix of storage, permissions, APK version, and Android battery rules—not a single magic toggle. Start with the problem card that matches your symptom, then work through the steps in order before you wipe data.',
				},
			]),
			p([
				{ text: 'Keep a recent chat backup before reinstalling. Grab the newest package from ' },
				{ link: { to: '/download/', text: 'Download GB WhatsApp APK' } },
				{ text: ', follow ' },
				{ link: { to: '/install-gbwhatsapp/', text: 'install steps' } },
				{ text: ' if the APK will not install, and check ' },
				{ link: { to: '/faq/', text: 'FAQ' } },
				{ text: ' for quick answers on bans and verification.' },
			]),
		],
		cards: [
			{
				icon: '⚠️',
				title: 'App Won’t Open or Stuck on Logo',
				symptoms: 'GB WhatsApp freezes on the splash screen or closes before chats load.',
				solutions: [
					'Force-stop the app, clear cache only (not data yet), and reopen.',
					'Confirm you are on the latest APK from the GBWaps download page.',
					'Disable battery optimization for GBWhatsApp on Xiaomi, Oppo, and Vivo phones.',
					'If still stuck, back up and reinstall over the same version before uninstalling.',
				],
			},
		],
	},
	{
		id: 'app-crashing',
		h2: 'App Crashing Fix',
		blocks: [
			p([
				{
					text: 'Crashes right after launch often mean a corrupted install, low RAM, or a mod build that does not match your CPU architecture. Updating in place fixes many cases; a clean reinstall is the last resort after backup.',
				},
			]),
		],
		cards: [
			{
				icon: '🔧',
				title: 'App Crashing',
				symptoms: 'GB WhatsApp closes unexpectedly after opening or when opening a specific chat.',
				solutions: [
					'Clear app cache: Settings → Apps → GBWhatsApp → Storage → Clear cache.',
					'Update to the latest version from the download page without uninstalling first.',
					'Reinstall the APK over the existing app; uninstall only if overlay install fails.',
					'Check Android version is 4.4+ and free at least 200 MB storage for cache growth.',
				],
			},
			{
				icon: '📱',
				title: 'Crash After Opening Camera or Gallery',
				symptoms: 'App dies when sending photos, videos, or opening the in-app camera.',
				solutions: [
					'Grant Storage and Camera permissions in Android app settings.',
					'Clear GBWhatsApp cache and retry with a smaller image file.',
					'Update the mod—older builds break on Android 13+ scoped storage rules.',
					'Restart the phone if MediaStore is stuck after a failed transfer.',
				],
			},
		],
	},
	{
		id: 'verification-code',
		h2: 'Verification Code Not Received',
		blocks: [
			p([
				{
					text: 'SMS and call verification depend on carrier signal, correct country code, and WhatsApp rate limits. Too many attempts in one hour can block new codes even when your number is valid.',
				},
			]),
		],
		cards: [
			{
				icon: '📩',
				title: 'SMS Code Never Arrives',
				symptoms: 'Timer runs out on “Verify your number” and no six-digit SMS appears.',
				solutions: [
					'Confirm airplane mode is off and you have mobile signal or Wi‑Fi calling for SMS.',
					'Double-check country code and number—no leading zero duplicated in the field.',
					'Tap “Call me” instead of SMS after the first failed wait.',
					'Wait 60 minutes before retrying; spamming requests triggers longer blocks.',
				],
			},
			{
				icon: '⏱️',
				title: 'Stuck on “Verifying”',
				symptoms: 'Spinner never finishes after entering the code.',
				solutions: [
					'Enable automatic date, time, and time zone in Android settings.',
					'Switch between Wi‑Fi and mobile data once, then force-stop and reopen.',
					'Install the latest APK—outdated mods fail handshake with servers.',
					'Temporarily disable VPN or ad-block DNS that filters WhatsApp endpoints.',
				],
			},
		],
	},
	{
		id: 'login-problems',
		h2: 'Login Problems Solution',
		blocks: [
			p([
				{
					text: 'Login loops and “session expired” messages usually mean an outdated package, a ban flag, or two apps fighting for the same number. Read the on-screen ban timer before you delete data.',
				},
			]),
		],
		cards: [
			{
				icon: '🔐',
				title: 'Cannot Log In After Update',
				symptoms: 'Previously worked account asks to register again or shows login failed.',
				solutions: [
					'Install the newest APK over the old one without uninstalling.',
					'If you see a temporary ban message, wait until the countdown ends.',
					'Restore from Google Drive or local backup when prompted after verify.',
					'Do not use the same number on official WhatsApp and GB at once unless your build supports dual mode.',
				],
			},
			{
				icon: '🚫',
				title: '“This account is not allowed”',
				symptoms: 'Hard stop during registration with policy-style wording.',
				solutions: [
					'Check if the number was permanently banned on official WhatsApp first.',
					'Try official WhatsApp once to read any account status message.',
					'Use a different number only where terms allow—evading bans can violate policy.',
					'See our anti-ban guide before installing another mod on a fresh SIM.',
				],
			},
		],
	},
	{
		id: 'installation-failed',
		h2: 'Installation Failed Fix',
		blocks: [
			p([
				{ text: '“App not installed” and parse errors almost always trace to blocked unknown sources, bad downloads, or leftover package conflicts. Full walkthrough: ' },
				{ link: { to: '/install-gbwhatsapp/', text: 'How to Install GB WhatsApp' } },
				{ text: '.' },
			]),
		],
		cards: [
			{
				icon: '📦',
				title: 'App Not Installed',
				symptoms: 'Installer closes with “App not installed” and no icon appears.',
				solutions: [
					'Enable Install unknown apps for your browser or Files app (Android 8+).',
					'Delete the APK, re-download, and confirm file size matches the download page.',
					'Uninstall other WhatsApp clones that share the same package name.',
					'Free at least 500 MB storage before retrying.',
				],
			},
			{
				icon: '⚙️',
				title: 'Parse Error or Package Invalid',
				symptoms: 'Android says the package is corrupt or cannot be parsed.',
				solutions: [
					'Download again on stable Wi‑Fi—partial files cause parse errors.',
					'Do not rename or unzip the APK; install the original .apk file.',
					'Pick an ARM build if your phone is 64-bit and the site offers arch variants.',
					'Update Android WebView and Google Play services from Play Store.',
				],
			},
		],
	},
	{
		id: 'storage-issues',
		h2: 'Storage Issues Fix',
		blocks: [
			p([
				{
					text: 'GB WhatsApp caches media, stickers, and backups on internal storage. Low space causes silent send failures, backup errors, and random crashes during status uploads.',
				},
			]),
		],
		cards: [
			{
				icon: '💾',
				title: 'Insufficient Storage',
				symptoms: 'Backup fails, media will not download, or installer reports not enough space.',
				solutions: [
					'Clear GBWhatsApp cache in system app settings (not data unless backed up).',
					'Move large videos to SD card or PC and delete old WhatsApp media folders.',
					'Remove duplicate APK files in Downloads after a successful install.',
					'Keep 1 GB free for updates and Google Drive restore operations.',
				],
			},
			{
				icon: '🗂️',
				title: 'Cannot Save to Gallery',
				symptoms: 'Status download or auto-save fails with permission errors.',
				solutions: [
					'Grant Photos and videos / Storage permission for GBWhatsApp.',
					'On Android 13+, allow granular media access when prompted.',
					'Create a “WhatsApp” folder on internal storage if OEM file managers block writes.',
					'Update the mod—old builds miss scoped storage hooks.',
				],
			},
		],
	},
	{
		id: 'message-sending',
		h2: 'Message Sending Issues',
		blocks: [
			p([
				{
					text: 'One check mark forever, upload stuck at 99%, or calls that never connect often point to network filters, clock skew, or account restrictions—not broken contacts.',
				},
			]),
		],
		cards: [
			{
				icon: '💬',
				title: 'Messages Stuck on Clock',
				symptoms: 'Single gray tick for hours; recipient never receives the text.',
				solutions: [
					'Test mobile data and Wi‑Fi; disable VPN and private DNS temporarily.',
					'Set automatic date and time, then force-stop GBWhatsApp.',
					'Check if you are banned or restricted—try sending to one contact first.',
					'Update APK and clear cache if only large media fails (compression issue).',
				],
			},
			{
				icon: '📤',
				title: 'Media Upload Fails',
				symptoms: 'Photos or videos hang on sending or fail with retry.',
				solutions: [
					'Compress video or send a shorter clip under mod size limits.',
					'Turn off data saver for GBWhatsApp in Android network settings.',
					'Clear cache, reboot, and resend on Wi‑Fi.',
					'Ask the receiver to update their client if they cannot download your file type.',
				],
			},
		],
	},
];
